export const avatarKeyMap = {
  'Avatar-0': 'default',
  'Avatar-8': 'man',
  'Avatar-2': 'man2',
  'Avatar-14': 'man3',
  'Avatar-4': 'man4',
  'Avatar-12': 'man5',
  'Avatar-6': 'man6',
  'Avatar-7': 'man7',
  'Avatar-16': 'man8',
  'Avatar-24': 'man9',
  'Avatar-28': 'man10',
  'Avatar-26': 'man11',
  'Avatar-22': 'man12',
  'Avatar-20': 'man13',
  'Avatar-18': 'man14',
  'Avatar-1': 'lady',
  'Avatar-9': 'lady2',
  'Avatar-10': 'lady3',
  'Avatar-11': 'lady4',
  'Avatar-5': 'lady5',
  'Avatar-13': 'lady6',
  'Avatar-3': 'lady7',
  'Avatar-15': 'lady8',
  'Avatar-19': 'lady9',
  'Avatar-23': 'lady10',
  'Avatar-27': 'lady11',
  'Avatar-25': 'lady12',
  'Avatar-21': 'lady13',
  'Avatar-17': 'lady14'
};

export const importAll = r => {
  return r.keys().map(filename => {
    return r(filename).default;
  });
};

export const imagesWithBg = importAll(
  require.context('../resources/avatars-with-bg', false, /\.(png|jpe?g|svg)$/)
);
export const imagesNoBg = importAll(
  require.context(
    '../resources/avatars-with-no-bg',
    false,
    /\.(png|jpe?g|svg)$/
  )
);

export const getImage = imageName => {
  const fileName = imageName && imageName.split('/').pop().split('.')[0];
  try {
    const image = imagesNoBg.find(img => {
      const baseFileName = img.split('/').pop().split('.')[0];
      const parts = baseFileName.split('-');
      const adjustedBaseFileName = parts.slice(0, -1).join('-');
      return adjustedBaseFileName.toLowerCase() === fileName.toLowerCase();
    });

    if (!image) {
      return null; // Image not found
    }
    return image;
  } catch (error) {
    console.error(`Error loading image: ${imageName}`, error);
    return null;
  }
};

export const getImageWithBackground = imageName => {
  try {
    const image = imagesWithBg.find(img => {
      const baseFileName = img.split('/').pop().split('.')[0];
      return baseFileName.toLowerCase() === imageName.toLowerCase();
    });

    if (!image) {
      return null; // Image not found
    }
    return image;
  } catch (error) {
    console.error(`Error loading image: ${imageName}`, error);
    return null;
  }
};
